module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Two-bottles-928abf47f785174409ff3385017739c3.svg";